export const requireFrontendBundle = (bundleName: string, callback: VoidFunction): void => {
  window.PMW.util.requireFrontendBundle(bundleName, callback);
};

export const isSelectorVisibleInDOM = (selector: string): boolean => {
  const el: HTMLElement | null = document.querySelector(selector);

  if (!el) {
    return false;
  }

  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
};

export const initNotificationsBundle = (): void => {
  if (!isSelectorVisibleInDOM('#js-notifications-button') || !window.PMW.isUserLoggedIn() || window.PMW.isStudent()) {
    return;
  }

  if (typeof window.PMW.initNotificationsDropdown === 'function') {
    window.PMW.initNotificationsDropdown();
    return;
  }

  requireFrontendBundle('notifications', () => {
    window.PMW.waitForGlobalFunction('initNotificationsDropdown')
      .then(() => {
        window.PMW.initNotificationsDropdown();
      })
      .catch((e: unknown) => {
        console.error(e);
      });
  });
};

export const initNavSearchBundle = (): void => {
  if (window.PMW.skipGlobalNavSearchInit === true) {
    return;
  }

  if ((!isSelectorVisibleInDOM('#js-nav-search') && !isSelectorVisibleInDOM('#js-gallery-search') && !document.querySelector('#js-nav-search-mobile')) || window.PMW.isStudent()) {
    return;
  }

  if (typeof window.PMW.initNavSearch === 'function') {
    window.PMW.initNavSearch();
    return;
  }

  requireFrontendBundle('nav-search', () => {
    window.PMW.waitForGlobalFunction('initNavSearch')
      .then(() => {
        window.PMW.initNavSearch();
      })
      .catch((e: unknown) => {
        console.error(e);
      });
  });
};

export const initDynamicallyLoadedBundlesNeededOnAllPages = (): void => {
  initNotificationsBundle();
  initNavSearchBundle();
};
